export const RESPONSE_SUCCESS = 'success'
export const RESPONSE_FAILED = 'failed'
export const ADMIN_VERSION_API = 'api/admin/v1';
export const FRONTEND_VERSION_API = 'api/v1'
